export default {
      id: "play-button-usage",
      viewBox: "0 0 314.068 314.068",
      url: __webpack_public_path__ + "app/svg/sprite.svg#play-button",
      toString: function () {
        return this.url;
      }
    }